import { render, staticRenderFns } from "./ResponsibilityBadgeHoldersTable.vue?vue&type=template&id=749397a8&scoped=true"
import script from "./ResponsibilityBadgeHoldersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityBadgeHoldersTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityBadgeHoldersTable.vue?vue&type=style&index=0&id=749397a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749397a8",
  null
  
)

export default component.exports